import { useTranslation } from "react-i18next";

import { SegmentedControl } from "@mantine/core";

import {
  COMMON_NAMESPACE,
  LOCALE_DEFS,
  LOCALES,
  toLocale,
} from "@prostocheck/i18n";

import { ILanguageSwitcherProps } from "./language-switcher.models";

/**
 * A control, not links: the dashboard has one URL per screen in every language,
 * so switching only changes the preference the detector remembers.
 */
export const LanguageSwitcher = ({ className }: ILanguageSwitcherProps) => {
  const { t, i18n } = useTranslation(COMMON_NAMESPACE);

  return (
    <SegmentedControl
      size="xs"
      className={className}
      aria-label={t("language.label")}
      value={toLocale(i18n.resolvedLanguage)}
      onChange={value => void i18n.changeLanguage(value)}
      data={LOCALES.map(locale => ({
        value: locale,
        label: LOCALE_DEFS[locale].shortName,
      }))}
    />
  );
};
